import { createFileRoute } from "@tanstack/react-router"

import { ArAgreementsSettings } from "@/features/settings/components/ar-agreements-settings"
import { agreementTemplateQueries } from "@/queries/agreement-templates"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(agreementTemplateQueries.versions()),
      context.queryClient.ensureQueryData(
        agreementTemplateQueries.placeholders()
      ),
    ]),
  staticData: { content: "edge-to-edge" },
  component: ArAgreementsSettings,
})
